module.exports = "\n<div class=\"comp-hero-rotating-image\">\n  <div class=\"hidden\" ref=\"input\">\n    <slot></slot>\n  </div>\n  <div class=\"image\" v-for=\"image in images\" :style=\"{ backgroundImage: 'url(' + image.url + ')' }\" :class=\"[image.active ? 'active' : '']\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/hero_rotating_image/index.pug
// module id = 676
// module chunks = 4